if (!customElements.get('product-tabs')) {
  class ProductTabs extends HTMLElement {
    constructor() {
      super();
      this.titles = this.querySelectorAll('.ProductTabs-title');

      this.boundHandleTitleClick = this.handleTitleClick.bind(this);
    }

    connectedCallback() {
      this.titles.forEach((title) => {
        title.addEventListener('click', this.boundHandleTitleClick);
      });
    }

    disconnectedCallback() {
      this.titles.forEach((title) => {
        title.removeEventListener('click', this.boundHandleTitleClick);
      });
    }

    handleTitleClick(e) {
      const target = e.target.closest('.ProductTabs-title');
      if (!target) return;

      const tabData = target.dataset.jsProductTab;

      this.querySelector('.ProductTabs-wrapper.is-active').classList.remove('is-active');
      this.querySelector('.ProductTabs-title.is-active').classList.remove('is-active');

      this.querySelector(`#${tabData}`).classList.add('is-active');
      target.classList.add('is-active');
    }
  }

  customElements.define('product-tabs', ProductTabs);
}
